import Header from 'modules/header/farm/main';
import Roles from 'modules/acount/roles';

const RolesPage = () => {
  return (
    <>
      <Header title="قوانین و مقررات" />
      <Roles app="farm" />
    </>
  );
};

export default RolesPage;
